import { Cruz3D } from './Cruz3D'
import { PecaDetalhe3D } from './PecaDetalhe3D'

export type TipoPredio = 'predio' | 'escola' | 'hospital'

/**
 * Prédio, escola ou hospital — corpo e teto arredondados, janelas em
 * material de vidro (como o para-brisa das viaturas), cimalha de
 * acabamento no topo, maçaneta na porta, e um acessório por tipo.
 */
export function FiguraPredio3D({
  tipo,
  cor,
}: {
  tipo: TipoPredio
  cor: string
}) {
  const corParede =
    tipo === 'hospital' ? '#dce9e7' : tipo === 'escola' ? '#f1c575' : cor
  return (
    <>
      <PecaDetalhe3D
        posicao={[0, 6, 0]}
        tamanho={[30, 12, 22]}
        cor={corParede}
        raio={0.15}
      />
      <PecaDetalhe3D
        posicao={[0, 12.5, 0]}
        tamanho={[32, 1, 24]}
        cor="#465662"
        raio={0.08}
      />
      <PecaDetalhe3D
        posicao={[0, 13.05, 0]}
        tamanho={[32.3, 0.1, 24.3]}
        cor="#8fa0aa"
        metal={0.3}
        rugosidade={0.4}
        raio={0.02}
      />
      {[0, Math.PI / 2, Math.PI, -Math.PI / 2].map((rotacao) => (
        <group key={rotacao} rotation={[0, rotacao, 0]}>
          {[-1, 0, 1].flatMap((i) =>
            [4.5, 8.5].map((y) => {
              const lateral = Math.abs(Math.sin(rotacao)) > 0.5
              const z = lateral ? 15.055 : 11.055
              const x = i * (lateral ? 6.4 : 9)
              return (
                <group key={`${i}-${y}`}>
                  <PecaDetalhe3D
                    posicao={[x, y, z]}
                    tamanho={[3.4, 2.65, 0.1]}
                    cor="#9aa8ab"
                    metal={0.35}
                    raio={0.015}
                  />
                  <PecaDetalhe3D
                    posicao={[x, y, z + 0.06]}
                    tamanho={[3.08, 2.37, 0.04]}
                    cor={VIDRO_JANELA}
                    metal={0.4}
                    rugosidade={0.15}
                    raio={0.01}
                  />
                  <PecaDetalhe3D
                    posicao={[x, y, z + 0.085]}
                    tamanho={[0.075, 2.4, 0.025]}
                    cor="#a7b6ba"
                    metal={0.45}
                    raio={0.008}
                  />
                </group>
              )
            }),
          )}
        </group>
      ))}
      <PecaDetalhe3D
        posicao={[0, 0.11, 12.1]}
        tamanho={[4.6, 0.22, 2]}
        cor="#859797"
        raio={0.035}
      />
      <PecaDetalhe3D
        posicao={[0, 4.2, 12]}
        tamanho={[5, 0.17, 2.2]}
        cor="#647b82"
        metal={0.35}
        raio={0.035}
      />
      <PecaDetalhe3D
        posicao={[-8, 13.42, -5]}
        tamanho={[4.2, 0.7, 2.7]}
        cor="#74858c"
        metal={0.5}
        raio={0.055}
      />
      {[-8.9, -7.1].map((x) => (
        <mesh
          key={x}
          position={[x, 13.795, -5]}
          rotation={[-Math.PI / 2, 0, 0]}
        >
          <circleGeometry args={[0.63, 14]} />
          <meshStandardMaterial color="#394c56" />
        </mesh>
      ))}
      <PecaDetalhe3D
        posicao={[0, 2, 11.05]}
        tamanho={[3.2, 4, 0.14]}
        cor="#2c2f33"
        raio={0.04}
      />
      <mesh position={[1.3, 2, 11.13]}>
        <boxGeometry args={[0.04, 0.05, 0.12]} />
        <meshStandardMaterial color="#d8dde0" metalness={0.6} roughness={0.3} />
      </mesh>
      {tipo === 'hospital' && (
        <group position={[0, 10.95, 11.13]} scale={2.2}>
          <Cruz3D />
        </group>
      )}
      {tipo === 'escola' && (
        <group position={[12, 13, 0]}>
          <mesh position={[0, 2.5, 0]} castShadow>
            <cylinderGeometry args={[0.1, 0.1, 5, 8]} />
            <meshStandardMaterial
              color="#9aa0a6"
              metalness={0.4}
              roughness={0.5}
            />
          </mesh>
          <mesh position={[0.6, 4.6, 0]}>
            <boxGeometry args={[1.2, 0.7, 0.04]} />
            <meshStandardMaterial color="#3b82f6" />
          </mesh>
        </group>
      )}
    </>
  )
}

const VIDRO_JANELA = '#1c2b33'
